import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './SecretaryChip.css';

const SectretaryChip = ({ info, extra, click, selected }) => {
  const containerClass = classNames({
    SecretarChip: true,
    SecretaryChipActive: selected
  });
  const infoClass = classNames({
    SecretaryChipMainPush: typeof extra !== 'undefined'
  });
  return (
    <div className={containerClass} onClick={click}>
      {typeof extra !== 'undefined' && (
        <span className="SecretarChipExtra">{extra}</span>
      )}
      <span className={infoClass}>{info}</span>
    </div>
  );
};

SectretaryChip.defaultProps = {
  extra: undefined,
  selected: false
};

SectretaryChip.propTypes = {
  info: PropTypes.string.isRequired,
  click: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  extra: PropTypes.number
};

export default SectretaryChip;



// WEBPACK FOOTER //
// ./src/components/SecretarChip.js